let loadingState = 0;
let listeners = new Set();
const incrementLoadingCount = () => {
  loadingState += 1;
  listeners.forEach(listener => listener());
};
const decrementLoadingCount = () => {
  loadingState = Math.max(0, loadingState - 1);
  listeners.forEach(listener => listener());
};
const getLoadingState = () => loadingState;
const subscribe = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// intended for testing purposes only
const resetState = () => {
  loadingState = 0;
  listeners = new Set();
};
export { incrementLoadingCount, decrementLoadingCount, subscribe, getLoadingState, resetState };
//# sourceMappingURL=loadingStore.js.map